import { FC } from "react";
import styled from "styled-components";

import { PageHeading, TeamHeading } from "@/components/Layout/Parts";
import TopTopicsTable from "./components/TopTopicsTable";

interface Props {
  category: string;
}

const StyledPageHeading = styled(PageHeading)`
  text-transform: capitalize;
`;

const TopTopics: FC<Props> = ({ category }) => {
  return (
    <>
      <TeamHeading />
      <StyledPageHeading>Top {category} Topics</StyledPageHeading>
      <TopTopicsTable category={category} />
    </>
  );
};

export default TopTopics;
